/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Coaching_RemainingInputs */

const en_coaching_remaining = /** @type {(inputs: Coaching_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} sessions available`)
};

const id_coaching_remaining = /** @type {(inputs: Coaching_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} sesi tersedia`)
};

/**
* | output |
* | --- |
* | "{n} sessions available" |
*
* @param {Coaching_RemainingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_remaining = /** @type {((inputs: Coaching_RemainingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_RemainingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_remaining(inputs)
	return en_coaching_remaining(inputs)
});